/**
 * @file JS - Class - DataPage.js
 * @author Adam Lemire
 * @since 2021/06/14
 * @version 1.0
 * @summary Dernières modifications : 2021/07/06
 */

import Page, { PageType } from './Page.js';
import VectorLayer from '../Layer/VectorLayer.js'; // eslint-disable-line no-unused-vars

/**
 * @typedef DataPage
 * @classdesc Classe représentant le contenu de la section d'une table d'attribut, aussi appelée PageTableau
 * @augments Page
 * */
export default class DataPage extends Page {
  /**
   * @param { VectorLayer } vectorLayer
   * @param { number } mapPageId
   */
  constructor (vectorLayer, mapPageId) {
    super(vectorLayer.id, vectorLayer.name, PageType.DATAPAGE);
    this._vectorLayer = vectorLayer;
    this._mapPageId = mapPageId;
    this._features = vectorLayer.features;
    this._conteneurId = '#datapage-' + mapPageId + '-' + vectorLayer.id;
  }

  get conteneurId () { return this._conteneurId; }

  get mapPageId () { return this._mapPageId; }

  get features () { return this._features; }

  get nomColonneId () { return this._vectorLayer.joinField; }

  registerListeners () {
    this._inscrireAuditeurNomCoucheChangee();
  }

  // ! à réviser, voir avec ci qui existe déjà dans Page.js
  async _inscrireAuditeurNomCoucheChangee () {
    const _this = this;
    const vectorLayer = await this._vectorLayer;

    vectorLayer.registerLayerNameChangedListener(function (nouveauNom) {
      _this.title = nouveauNom;
      _this._notifierNomCoucheChangee();
    });
  }

  _notifierNomCoucheChangee () {}

  registerLayerNameChangedListener (listener) {
    this._notifierNomCoucheChangee = listener;
  }
}
